module.exports = __webpack_public_path__ + "img/pytech_logo.82ed8f2b.png";